import axios from 'axios'
import {VmView} from 'components'
import AlertOk from 'components/AlertOk'
import AlertYesNo from 'components/AlertYesNo'
import {ProgressFullScreen} from 'molecules'
import QueryString from 'qs'
import {useEffect, useRef, useState} from 'react'
import {toCurrency} from 'utils/functions'

export const ModalTambahObatKFA = ({
  isOpen,
  onClose,
  kl_id = 0,
  refetchData = () => {},
}) => {
  const refConfirmation = useRef()
  const resInformation = useRef()
  const [searchTerm, setSearchTerm] = useState('')
  const [keyword, setKeyword] = useState('')
  const [items, setItems] = useState([])
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const [loadingProgress, setLoadingProgress] = useState(false)

  const fetchObat = async () => {
    if (loading || !hasMore) return // Prevent multiple requests
    setLoading(true)

    try {
      const {data: res} = await axios.post(
        process.env.REACT_APP_BASE_URL_SATUSEHAT + '/satusehat-obat/get-obat',
        QueryString.stringify({
          a: 'dk13_' + kl_id,
          kl_id,
          page,
          limit: 25,
          keyword,
        })
      )

      if (res) {
        const dataObat = res?.data?.items?.data ?? []
        setItems(prevItems => [...prevItems, ...dataObat])
        setHasMore(dataObat?.length > 0) // Check if more items are available
      } else {
        console.log('Error get Data Obat')
      }
    } catch (err) {
      console.log('Error get Data Obat', err.message)
    } finally {
      setLoading(false)
    }
  }

  const onSelectItem = item => {
    refConfirmation.current.show(
      {
        message: `Apakah anda yakin ingin menambah obat ${item.name} untuk menjadi obat baru ?`,
      },
      () => {
        setLoadingProgress(true)
        axios
          .post(
            process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/create',
            QueryString.stringify({
              a: 'dk13',
              uid: kl_id,
              item: JSON.stringify(item),
            })
          )
          .then(({data: res}) => {
            if (res?.status === 1) {
              resInformation.current.show(
                {
                  message: 'Data obat berhasil disimpan',
                  type: 'success',
                  title: 'Informasi',
                },
                onClose
              )
              refetchData()
            } else {
              resInformation.current.show({
                message: res?.message,
                type: 'warning',
                title: 'Informasi',
              })
            }
          })
          .catch(err => {
            resInformation.current.show({
              message: 'Gagal menyimpan data obat',
            })
            console.error('Error get Data Obat', err.message)
          })
          .finally(() => {
            setLoadingProgress(false)
          })
      }
    )
  }

  useEffect(() => {
    fetchObat()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, keyword])

  useEffect(() => {
    if (!isOpen) {
      setKeyword('')
      setSearchTerm('')
      setItems([])
      setPage(1)
      setHasMore(true)
    }
  } , [isOpen])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-3">
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <VmView className="bg-white rounded-lg shadow-lg p-6 z-10 w-full md:w-1/2">
        <h2 className="text-xl font-semibold mb-4">Pilih Obat</h2>

        {/* Search Bar */}
        <div className="mb-4 flex">
          <input
            type="text"
            value={searchTerm}
            onChange={e => {
              setSearchTerm(e.target.value)
            }}
            placeholder="Cari Obat..."
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            onKeyDown={e => {
              if (e.key === 'Enter') {
                setKeyword(searchTerm)
                setItems([])
                setPage(1)
                setHasMore(true)
              }
            }}
          />
          <button className="bg-blue-500 text-white p-2 rounded-lg ml-2" onClick={() => {
            setKeyword(searchTerm)
            setItems([])
            setPage(1)
            setHasMore(true)
          }}>
            Cari
          </button>
        </div>

        <VmView className="max-h-[70vh] overflow-auto">
          {items.length > 0
            ? items.map((item, index) => (
                <VmView
                  key={index}
                  className="mb-4 border-b-2 pb-2 flex justify-between items-center"
                >
                  <div>
                    <label className="block text-gray-900 mb-1">
                      {item?.product_template?.display_name}
                    </label>
                    <label className="block text-gray-700 mb-1 text-sm">
                      {item?.product_template?.kfa_code}
                    </label>
                    <label className="block text-blue-600 mb-1 text-sm">
                      Rp. {toCurrency(item?.het_price ?? 0)} /{item?.uom?.name}
                    </label>
                  </div>
                  <button
                    onClick={() => onSelectItem(item)}
                    className="bg-blue-500 text-white text-xs p-1 rounded-lg"
                  >
                    Pilih
                  </button>
                </VmView>
              ))
            : !loading && (
                <div className="text-gray-500">
                  Tidak ada obat yang ditemukan.
                </div>
              )}
          {hasMore && (
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setPage(prevPage => prevPage + 1)}
                className="bg-gray-300 text-black text-xs p-2 rounded-lg"
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Load More'}
              </button>
            </div>
          )}
        </VmView>

        <button
          onClick={onClose}
          className="mt-4 bg-blue-500 text-white p-2 rounded-lg"
        >
          Tutup
        </button>
      </VmView>

      <AlertOk ref={resInformation} />
      <AlertYesNo ref={refConfirmation} />
      <ProgressFullScreen visible={loadingProgress} />
    </div>
  )
}
